import { createFileRoute } from '@tanstack/react-router'
import { TablesListView } from '../../../components/tables/TablesListView'

export const Route = createFileRoute('/_authenticated/tables/')({
  component: TablesPage,
})

function TablesPage() {
  return (
    <div className="container mx-auto p-6">
      <TablesListView />
    </div>
  )
}
